import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import FontIcon from 'material-ui/FontIcon';
import { blue500 } from 'material-ui/styles/colors';

class UploadScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filesPreview: [],
      filesToBeSent: [],
      printcount: 20,
      overallFileSize: 0,
    };
    this.removeDocumentHandler = this.removeDocumentHandler.bind(this);
  }

  handleClick(event) {
    if (this.state.filesToBeSent.length > 0) {
      return this.state.filesToBeSent;
    } else {
      alert('Please upload some files first');
    }
  }

  onDrop(acceptedFiles, rejectedFiles) {
    let filesToBeSent = this.state.filesToBeSent;
    let filesArr = [];
    if (this.state.uploadLimitExceeded) {
      filesArr = filesToBeSent(acceptedFiles);
    } else {
      filesArr = filesToBeSent.concat(acceptedFiles);
    }
    if (filesToBeSent.length < this.state.printcount) {
      this.setState({ filesToBeSent: filesArr });
      this.props.calculateFileSizehandler(filesArr);
    } else {
      alert('You have reached the limit of printing files at a time');
    }
  }

removeDocumentHandler = (e, index) => {
  e.preventDefault();
  // console.log(index);
  if (parseInt(index, 10) > -1) {
    let arr = this.state.filesToBeSent;
    arr.splice(index, 1);
    this.setState({ filesToBeSent: arr });
    this.props.calculateFileSizehandler(arr);
    //   console.log(arr);
  }
}

renderFilePreview() {
  let totalFileSize = 0;
  // @desc - define const max upload file size 5MB
  const fileSize5MB = 20.00;
  let loopCount = 0;
  return this.state.filesToBeSent.map((obj, i) => {

    totalFileSize = totalFileSize + obj.size;
    let totalFileSizeInMB = ((totalFileSize / 1024) / 1024).toFixed(2);

    let fileSizeInKB = Math.round(obj.size / 1024); // converted bytes(incoming file size) to KB.
    // 1024kb = 1MB
    let fileSizeInMB = Math.round((obj.size / 1024) / 1024);
    let fileSizeInMBFixTo2Decimal = fileSizeInMB.toFixed(2);
    let fileSize = fileSizeInKB >= 1024 ? `${fileSizeInMBFixTo2Decimal}MB` : `${fileSizeInKB}KB`;

    loopCount = loopCount + 1;
    // console.log(totalFileSizeInMB, fileSize5MB, loopCount, parseFloat(totalFileSizeInMB) > parseFloat(fileSize5MB));

    if (parseFloat(totalFileSizeInMB) > parseFloat(fileSize5MB)) {
      return (
        <div key={i}>
          <div>
            <img src={obj.preview} width={50} height={50} alt="" />
            <div>
              {fileSize} &nbsp;   {obj.name}
            </div>
            <FontIcon
              onClick={(e) => this.removeDocumentHandler(e, i)}
              className="material-icons customstyle"
              color={blue500}
            >clear</FontIcon>
          </div>
          <div className="documentSizeChecker">Total size of docs must not exceed 20MB.</div>
        </div>
      );
    } else {

      return (
        <div key={`plain${i}`}>
          <div>
            <img src={obj.preview} width={50} height={50} alt="" />
            <div>
              {fileSize}  &nbsp; {obj.name}

            </div>
            <FontIcon
              onClick={(e) => this.removeDocumentHandler(e, i)}
              className="material-icons customstyle"
              color={blue500}
            >clear</FontIcon>
          </div>
        </div>
      );
    }
  });
}

render() {
  return (
    <div className="App">
      <div className="row">
        <div className="col-sm-6">
          <div className="info">
                        You can upload upto {this.state.printcount} files at a time.
          </div>
          <Dropzone onDrop={(files) => this.onDrop(files)} multiple={true}>
            <div>Click to select files to upload.</div>
            <br />
            <div>YOU CAN ONLY UPLOAD (.jpeg, .jpg, .png, .doc, .docx, .pdf, .txt, .xlsx, .pptx)</div>
          </Dropzone>
        </div>
        <div className="col-sm-6">
          <div>
                        Files to be uploaded are:
            {this.renderFilePreview()}
          </div>
          <div>
            {this.state.printingmessage}
          </div>
        </div>
      </div>
    </div>
  );
}
}

export default UploadScreen;



// WEBPACK FOOTER //
// ./src/modules/scheduling/UploadDocumentScreen.js